var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSpaces(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.191177 3.05905C0.191177 1.4753 1.47507 0.191406 3.05882 0.191406H22.9412C24.5249 0.191406 25.8088 1.4753 25.8088 3.05905V22.9414C25.8088 24.5252 24.5249 25.8091 22.9412 25.8091H3.05882C1.47507 25.8091 0.191177 24.5252 0.191177 22.9414V3.05905ZM3.05882 1.33847C2.10857 1.33847 1.33824 2.1088 1.33824 3.05905V22.9414C1.33824 23.8917 2.10857 24.662 3.05882 24.662H22.9412C23.8914 24.662 24.6618 23.8917 24.6618 22.9414V3.05905C24.6618 2.1088 23.8914 1.33847 22.9412 1.33847H3.05882Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.36765 10.706C9.36765 9.54455 10.3092 8.60303 11.4706 8.60303H14.5294C15.6908 8.60303 16.6324 9.54455 16.6324 10.706V11.4707C16.6324 11.7874 16.3756 12.0442 16.0588 12.0442C15.7421 12.0442 15.4853 11.7874 15.4853 11.4707V10.706C15.4853 10.178 15.0573 9.75009 14.5294 9.75009H11.4706C10.9427 9.75009 10.5147 10.178 10.5147 10.706V11.4707C10.5147 11.7874 10.2579 12.0442 9.94117 12.0442C9.62442 12.0442 9.36765 11.7874 9.36765 11.4707V10.706Z",
    fill: "inherit"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3088 16.8235C19.3088 16.5068 19.5656 16.25 19.8824 16.25H22.9514C24.4667 16.25 25.8088 17.3604 25.8088 18.8627V19.8824C25.8088 20.1991 25.552 20.4559 25.2353 20.4559C24.9185 20.4559 24.6618 20.1991 24.6618 19.8824V18.8627C24.6618 18.1127 23.9588 17.3971 22.9514 17.3971H19.8824C19.5656 17.3971 19.3088 17.1403 19.3088 16.8235Z",
    fill: "inherit"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.69118 16.8235C6.69118 16.5068 6.4344 16.25 6.11765 16.25H3.04863C1.53335 16.25 0.191177 17.3604 0.191177 18.8627V19.8824C0.191177 20.1991 0.447955 20.4559 0.764707 20.4559C1.08146 20.4559 1.33824 20.1991 1.33824 19.8824V18.8627C1.33824 18.1127 2.04116 17.3971 3.04863 17.3971H6.11765C6.4344 17.3971 6.69118 17.1403 6.69118 16.8235Z",
    fill: "inherit"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1324 5.353C10.1324 3.76924 11.4162 2.48535 13 2.48535C14.5838 2.48535 15.8676 3.76924 15.8676 5.353C15.8676 6.93676 14.5838 8.22065 13 8.22065C11.4162 8.22065 10.1324 6.93676 10.1324 5.353ZM13 3.63241C12.0497 3.63241 11.2794 4.40274 11.2794 5.353C11.2794 6.30325 12.0497 7.07359 13 7.07359C13.9503 7.07359 14.7206 6.30325 14.7206 5.353C14.7206 4.40274 13.9503 3.63241 13 3.63241Z",
    fill: "inherit"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5441 13C18.5441 11.4162 19.828 10.1323 21.4118 10.1323C22.9955 10.1323 24.2794 11.4162 24.2794 13C24.2794 14.5837 22.9955 15.8676 21.4118 15.8676C19.828 15.8676 18.5441 14.5837 18.5441 13ZM21.4118 11.2794C20.4615 11.2794 19.6912 12.0497 19.6912 13C19.6912 13.9502 20.4615 14.7206 21.4118 14.7206C22.362 14.7206 23.1323 13.9502 23.1323 13C23.1323 12.0497 22.362 11.2794 21.4118 11.2794Z",
    fill: "inherit"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.45589 13C7.45589 11.4162 6.172 10.1323 4.58824 10.1323C3.00448 10.1323 1.72059 11.4162 1.72059 13C1.72059 14.5837 3.00448 15.8676 4.58824 15.8676C6.172 15.8676 7.45589 14.5837 7.45589 13ZM4.58824 11.2794C5.53849 11.2794 6.30883 12.0497 6.30883 13C6.30883 13.9502 5.53849 14.7206 4.58824 14.7206C3.63798 14.7206 2.86765 13.9502 2.86765 13C2.86765 12.0497 3.63798 11.2794 4.58824 11.2794Z",
    fill: "inherit"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4027 13.5733C9.6008 13.5733 8.90521 14.1273 8.72577 14.9089L6.67663 23.834C6.60575 24.1427 6.29803 24.3355 5.98931 24.2647C5.68059 24.1938 5.48778 23.8861 5.55866 23.5773L7.6078 14.6522C7.90687 13.3496 9.06619 12.4263 10.4027 12.4263H15.4027C16.7097 12.4263 17.8513 13.31 18.1788 14.5753L20.4376 23.3008C20.517 23.6075 20.3327 23.9204 20.0261 23.9998C19.7194 24.0792 19.4065 23.8949 19.3271 23.5883L17.0684 14.8627C16.8719 14.1036 16.1869 13.5733 15.4027 13.5733H10.4027Z",
    fill: "inherit"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaces);
export default __webpack_public_path__ + "static/media/Spaces.a08626ef359c55211bdbeab5145e97b8.svg";
export { ForwardRef as ReactComponent };